package com.shadowings.gero.data.lessons.chapter7
import com.shadowings.gero.data.lessons.buildHieroQuizContent
import com.shadowings.gero.data.lessons.chapter1.famousNames
import com.shadowings.gero.data.lessons.chapter1.getUni1Content
import com.shadowings.gero.data.lessons.chapter1.getUni2Content
import com.shadowings.gero.data.lessons.chapter2.animalNames
import com.shadowings.gero.data.lessons.chapter2.foodNames
import com.shadowings.gero.data.lessons.chapter2.getHieroAnimalsContent
import com.shadowings.gero.data.lessons.chapter2.getHieroFood2Content
import com.shadowings.gero.data.lessons.chapter2.getHieroFoodContent
import com.shadowings.gero.data.lessons.chapter2.getHieroHumansContent
import com.shadowings.gero.data.lessons.chapter2.humanNames
import com.shadowings.gero.data.lessons.chapter3.getHieroVarieContent
import com.shadowings.gero.data.lessons.chapter3.vocabVarieWords
import com.shadowings.gero.data.lessons.chapter4.royalNameWordIds
import com.shadowings.gero.data.lessons.chapter5.getHieroVerbs1Content
import com.shadowings.gero.data.lessons.chapter5.getHieroVerbs2Content
import com.shadowings.gero.data.lessons.chapter5.getHieroVerbs3Content
import com.shadowings.gero.data.lessons.chapter5.toHieroList
import com.shadowings.gero.data.lessons.chapter5.vocabVerbs1WordIds
import com.shadowings.gero.data.lessons.chapter5.vocabVerbs2WordIds
import com.shadowings.gero.data.lessons.chapter5.vocabVerbs3WordIds
import com.shadowings.gero.data.lessons.chapter6.getHieroVerbs4Content
import com.shadowings.gero.data.lessons.chapter6.vocabVerbs4WordIds
import com.shadowings.gero.data.lessons.toHieroExplanation


import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_title_hiero_vso_1
import gero.composeapp.generated.resources.exp_content_studiamo_hiero_vso_1
import gero.composeapp.generated.resources.swipe_up

fun getHieroVso1Content(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IExplanation> {
    val previous = (famousNames + foodNames + animalNames + humanNames + vocabVarieWords + royalNameWordIds + vocabVerbs1WordIds + vocabVerbs2WordIds + vocabVerbs3WordIds + vocabVerbs4WordIds).toHieroList(words)
    val current = vocabVso1WordIds.toHieroList(words)

    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_hiero_vso_1,
            content = Res.string.exp_content_studiamo_hiero_vso_1,
            face = Faces.Happy,
            image = Res.drawable.swipe_up,
            imageSize = 0.35f,
        ),
    ) + current.filter { it !in previous }.toHieroExplanation(hiero, languageCode)
}

fun getHieroVso1QuizContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    val previousContent = getUni1Content(hiero, words, languageCode) +
            getUni2Content(hiero, words, languageCode) +
            getHieroFoodContent(hiero, words, languageCode) +
            getHieroFood2Content(hiero, words, languageCode) +
            getHieroAnimalsContent(hiero, words, languageCode) +
            getHieroHumansContent(hiero, words, languageCode) +
            getHieroVerbs1Content(hiero, words, languageCode) +
            getHieroVerbs2Content(hiero, words, languageCode) +
            getHieroVerbs3Content(hiero, words, languageCode) +
            getHieroVerbs4Content(hiero, words, languageCode) +
            getHieroVarieContent(hiero, words, languageCode)

    return buildHieroQuizContent(
        hiero = hiero,
        hieroContent = getHieroVso1Content(hiero, words, languageCode),
        languageCode = languageCode,
        previousHieroContent = previousContent
    )
}
